export default __webpack_public_path__ + "static/media/icon7.f1fbedc5.svg";